import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-phone-input-2/lib/style.css";
import { Modal, Form, Button, Row, Alert } from "react-bootstrap";
import axios from "../../axios";
import apiError from "../../error";
import Spinner from "../spinner/spinner";
import "./rightside-modal.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { IoInformationOutline } from "react-icons/io5";
export default class RightSideModalScheduler extends Component {
    state = {
        domains: [],
        loading: false,
        disableBtn: false,
        disabledEdit: true,
        statusCheck: false,
        phone: this.props.phone,
        email: this.props.email,
        targetId: this.props.targetId,
        lastname: this.props.lastname,
        overrule: false,
        overruleLoc: false,
        department: this.props.department,
        location: this.props.location,
        position: this.props.position,
        firstname: this.props.firstname,
        isTASyncing: false,
        selectedOption: null,
        selectedFrequency: 'Daily',
        campaignList: [],
        enteredEmails: [],
        selectedCampaign: { label: "", value: "" },
        attackType: '',
        startTime: '',
        simulationExpiresOn: '',
        isFollowUpCampaign: false,
        followUpOption: "",
        selectedLanguage: 'en',
    }

    languageOptions = [
        { value: 'en', label: 'English' },
        { value: 'id', label: 'Bahasa' },
        { value: 'ar', label: 'Arabic' },
    ];

    handleLanguageChange = (e) => {
        const languageCode = e.target.value;
        this.setState({ selectedLanguage: languageCode });
    }


    loadCampaigns = async () => {
        this.setState({ loading: true });
        try {
            const res = await axios.get('/api/campaigns/not-scheduled-report-list', {
                params: {
                    limit: 100,
                    search: this.state.search
                }
            });
            this.setState({
                campaignList: res.data.campaigns.map(c => {
                    return {
                        value: c.id,
                        label: c.name,
                        attackType: c?.attack_type?.name,
                        expiresOn: c.expiresOn
                    }
                }), loading: false
            }, () => {
                if(this.props.campaignId){
                    let selectedCampaign = this.state.campaignList.find(c => c.value === this.props.campaignId);
                    this.setState({selectedCampaign: selectedCampaign, attackType: selectedCampaign?.attackType || ''});
                    
                }
            });
        } catch (err) {
            this.setState({ loading: false });
            apiError(err);
        }
    }

    componentDidMount() {
        this.loadCampaigns();
    }

    formatLocalDate(dateInput) {
        const date = new Date(dateInput);
        const pad = n => String(n).padStart(2, '0');

        return (
            date.getFullYear() + "-" +
            pad(date.getMonth() + 1) + "-" +
            pad(date.getDate()) + "T" +
            pad(date.getHours()) + ":" +
            pad(date.getMinutes())
        );
    }

    componentDidUpdate(prevProps) {
        if (prevProps.campaignReportScheduler !== this.props.campaignReportScheduler && this.props.campaignReportScheduler?.id) {
            let startTime = this.props.campaignReportScheduler?.startTime;
            if (startTime) {
                const [hours, minutes] = startTime.split(':').map(Number);
                const utcDate = new Date();
                utcDate.setUTCHours(hours, minutes, 0, 0);

                const localHours = String(utcDate.getHours()).padStart(2, '0');
                const localMinutes = String(utcDate.getMinutes()).padStart(2, '0');
                startTime = `${localHours}:${localMinutes}`;
            }

            const languageCode = this.props.campaignReportScheduler?.languageCode || 'en';
            
            this.setState({
                enteredEmails: this.props.campaignReportScheduler?.emails?.map(email => {
                    return { label: email, value: email }
                }) || [],
                selectedCampaign: this.props.campaignReportScheduler?.campaignId ? { value: this.props.campaignReportScheduler?.campaignId, label: this.props.campaignReportScheduler?.campaign?.name } : null,
                attackType: this.props.campaignReportScheduler?.campaign?.attack_type?.name || '',
                startTime: startTime,
                selectedFrequency: this.props.campaignReportScheduler?.frequency === 'daily' ? 'Daily' : 'On Expiry',
                simulationExpiresOn: this.props.campaignReportScheduler?.completesOn || '',
                selectedLanguage: languageCode
            });
        }
    }

    handleChange = (selectedOption) => {
        this.setState({ selectedOption });
    }
    handleFrequencyChange = (frequency) => {
        this.setState({ selectedFrequency: frequency });
    }
    handleCampaignSelection = (newValue) => {
        this.setState({ selectedCampaign: newValue });
        const selectedCampaign = this.state.campaignList.find(c => c.value === newValue.value);
        if (selectedCampaign && selectedCampaign.attackType) {
            this.setState({ attackType: selectedCampaign.attackType, simulationExpiresOn: selectedCampaign.expiresOn });
        } else {
            this.setState({ attackType: '' });
        }
    }
    validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    handleAddRecipientEmails = (newValue) => {
        if (newValue.length > this.state.enteredEmails.length) {
            let addedEmail = newValue[newValue.length - 1].label;
            if (this.validateEmail(addedEmail)) {
                this.setState({ enteredEmails: newValue });
            } else {
                toast.error("Please enter a valid email address");
            }
        } else {
            this.setState({ enteredEmails: newValue });
        }
    }

    validate = () => {
        let data = {};
        if (!this.state.selectedCampaign?.value) {
            toast.error("Please select a campaign");
            return false;
        }
        data.campaignId = this.state.selectedCampaign?.value;

        data.frequency = this.state.selectedFrequency === "Daily" ? "daily" : "on-expiry";

        if (this.state.selectedFrequency === "Daily" && !this.state.startTime) {
            toast.error("Please set a start time");
            return false;
        }
        if (data.frequency === "daily") {
            const [hours, minutes] = this.state.startTime.split(':').map(Number);

            const local = new Date();
            local.setHours(hours, minutes, 0, 0);

            const utcHours = local.getUTCHours().toString().padStart(2, '0');
            const utcMinutes = local.getUTCMinutes().toString().padStart(2, '0');
            const utcTime = `${utcHours}:${utcMinutes}`;
            data.startTime = utcTime;
        }

        if (this.state.enteredEmails.length === 0) {
            toast.error("Please enter at least one recipient email");
            return false;
        }
         data.languageCode = this.state.selectedLanguage || 'en';

        data.emails = this.state.enteredEmails.map(e => e.label);
        return data;
    }

    handleAddScheduler = async () => {
        try {
            let validateData = this.validate();
            if (!validateData) return;
            this.setState({ loading: true });
            const response = await axios.post('/api/pdfReport/add-campaign-report-scheduler', validateData);
            toast.success(response.data.message);
            this.setState({ loading: false });
            this.handleClose();
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }
    handleUpdateScheduler = async () => {
        try {
            let validateData = this.validate();
            if (!validateData) return;
            delete validateData.campaignId; // campaign Id should not be updated
            this.setState({ loading: true });
            const response = await axios.post(`/api/pdfReport/update-campaign-report-scheduler/${this.props.campaignReportScheduler.id}`, validateData);
            toast.success(response.data.message);
            this.setState({ loading: false });
            this.handleClose();
        } catch (error) {
            this.setState({ loading: false });
            apiError(error);
        }
    }


    resetStates = () => {
        this.setState({
            selectedOption: null,
            selectedFrequency: 'Daily',
            enteredEmails: [],
            selectedCampaign: null,
            attackType: '',
            startTime: '',
            loading: false,
            selectedLanguage: 'en'
        });
    }

    handleClose = () => {
        this.resetStates();
        this.props.handleModal(false);
        this.loadCampaigns();
    }

    formatExpiry(expiresAt) {
        const exp = new Date(expiresAt);
        if (isNaN(exp)) return "";

        const now = new Date();
        let diffMs = exp - now;

        const dd = String(exp.getDate()).padStart(2, '0');
        const mm = String(exp.getMonth() + 1).padStart(2, '0');
        const yyyy = String(exp.getFullYear());
        const hours = exp.getHours();
        const minutes = exp.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const hour12 = hours % 12 === 0 ? 12 : hours % 12;
        const timePart = `${hour12}:${String(minutes).padStart(2, '0')} ${ampm}`;
        const datePart = `${dd}-${mm}-${yyyy}`;

        if (diffMs > 0) {
            const diffDays = Math.floor(diffMs / (24 * 60 * 60 * 1000));
            diffMs -= diffDays * 24 * 60 * 60 * 1000;
            const diffHours = Math.floor(diffMs / (60 * 60 * 1000));
            diffMs -= diffHours * 60 * 60 * 1000;
            const diffMinutes = Math.floor(diffMs / (60 * 1000));
            diffMs -= diffMinutes * 60 * 1000;
            const diffSeconds = Math.floor(diffMs / 1000);

            if (diffDays > 0) {
                const unit = diffDays === 1 ? 'day' : 'days';
                return `${diffDays} ${unit} (${datePart})`;
            } else if (diffHours > 0) {
                const unit = diffHours === 1 ? 'hr' : 'hrs';
                return `${diffHours} ${unit} (${timePart})`;
            } else if (diffMinutes > 0) {
                const unit = diffMinutes === 1 ? 'min' : 'mins';
                return `${diffMinutes} ${unit} (${timePart})`;
            } else if (diffSeconds > 0) {
                const unit = diffSeconds === 1 ? 'sec' : 'secs';
                return `${diffSeconds} ${unit} (${timePart})`;
            } else {
                return `0 sec (${timePart})`;
            }
        } else {
            // Already expired
            const diffDays = Math.abs(Math.ceil(diffMs / (24 * 60 * 60 * 1000)));
            const unit = diffDays === 1 ? 'day' : 'days';
            return `${diffDays} ${unit} ago (${datePart})`;
        }
    }

    render() {

        const frequencies = ['Daily', 'On Expiry'];
        return (
            <Modal className="info-filter right mainfooterModal right-modal-wrap" show={this.props.show} onHide={this.handleClose} autoFocus keyboard>
                <Modal.Header closeButton>
                    <div>
                        <h5>{this.props.campaignReportScheduler?.id ? "Update " : "Add "}Scheduler</h5>
                        <p>Schedule yours reports</p>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="addUserDetail">
                        <Row>
                            {/* {!this.props.directFromReport && */}
                        
                                <div className="col-md-6 mb-2">
                                    <Form.Label>Select Campaign<span className="red-star">*</span></Form.Label>
                                    <Select
                                        value={this.state.selectedCampaign?.value ? this.state.selectedCampaign : ""}
                                        onChange={this.handleCampaignSelection}
                                        options={this.state.campaignList}
                                        placeholder="Select Campaign"
                                        className="basic-single"
                                        classNamePrefix="selectFontSize"
                                        isDisabled={(this.props.campaignReportScheduler && (this.props.campaignReportScheduler.id ? true : false)) || this.props.campaignId}
                                    />
                                    </div>
                            
                                
                                <div className="col-md-6 mb-2">
                                    <Form.Group>
                                        <Form.Label>Attack Vector<span className="red-star">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.attackType}
                                            placeholder=""
                                            disabled
                                        />
                                    </Form.Group>
                                </div>
                            

                            <div className="col-md-12 mb-2">
                                <Alert variant="warning" className="alert-sm alert-with-icon ">
                                    <IoInformationOutline className="info-icon" /> Includes scheduling of reports for all linked follow-up campaigns
                                </Alert>
                            </div>

                             <div className="col-md-6 mb-3">
                                <Form.Label>Select Language<span className="red-star">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    value={this.state.selectedLanguage}
                                    onChange={this.handleLanguageChange}
                                    disabled={this.props.campaignReportScheduler?.id && (this.props.campaignReportScheduler.status !=="Active" ? true : false)}
                                    className="form-control"
                                >
                                    {this.languageOptions.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Control>
                            </div>



                            <div className="col-md-12 mb-3 ">
                                <Form.Label>Frequency<span className="red-star">*</span></Form.Label>
                                <ul className="frequency-list">
                                    {frequencies.map((frequency) => (
                                        <li
                                            key={frequency}
                                            className={this.state.selectedFrequency === frequency ? 'active' : ''}
                                            onClick={() => this.handleFrequencyChange(frequency)}
                                            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}
                                        >
                                            <input
                                                type="radio"
                                                name="frequency"
                                                value={frequency}
                                                checked={this.state.selectedFrequency === frequency}
                                                onChange={() => this.handleFrequencyChange(frequency)}
                                                style={{ accentColor: "#007bff" }}
                                                disabled={this.props.campaignReportScheduler?.id && (this.props.campaignReportScheduler.status !=="Active" ? true : false)}
                                            />
                                            {frequency}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="col-md-12 mb-3 note-section-normal">
                                {this.state.selectedFrequency === "Daily" &&
                                    <div>If you set the frequency to "Daily", you'll receive campaign reports every day until your campaign expires.</div>
                                }
                                {this.state.selectedFrequency === "On Expiry" &&
                                    <div>If you set the frequency to "On Expiry", you'll receive the campaign report only once, after the campaign ends.</div>
                                }
                            </div>
                            {this.state.selectedFrequency === "Daily" &&
                                <div className="col-md-6 mb-2">
                                    <Form.Group>
                                        <Form.Label>Set Time<span className="red-star">*</span></Form.Label>
                                        <Form.Control
                                            type="time"
                                            placeholder="Select Date"
                                            value={this.state.startTime}
                                            // onChange={(e) => this.setState({ startTime: e.target.value })}
                                            onChange={(e) => this.setState({ startTime: e.target.value })}
                                            ref={input => this.timeInput = input}
                                            onClick={() => this.timeInput && this.timeInput.showPicker && this.timeInput.showPicker()}
                                            disabled={this.props.campaignReportScheduler?.id && (this.props.campaignReportScheduler.status !=="Active" ? true : false)}
                                        />
                                    </Form.Group>

                                </div>
                            }

                            <div className="col-md-12 mb-4">
                                <label className="form-label">Recipients<span className="red-star">*</span></label>
                                <CreatableSelect
                                    isMulti
                                    isClearable
                                    value={this.state.enteredEmails}
                                    onChange={this.handleAddRecipientEmails}
                                    placeholder="Type recipient email and press enter"
                                    isDisabled={this.props.campaignReportScheduler?.id && (this.props.campaignReportScheduler.status !=="Active" ? true : false)}
                                    components={{
                                        DropdownIndicator: null,
                                        IndicatorSeparator: null,
                                        Menu: () => null, // ❌ Hides dropdown menu component
                                    }}

                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            borderColor: "#ced4da",
                                            boxShadow: "none",
                                            "&:hover": {
                                                borderColor: "#ced4da",
                                            },
                                        }),
                                        placeholder: (base) => ({
                                            ...base,
                                            fontSize: "0.875rem",
                                            color: "#6c757d",
                                        }),
                                        multiValue: (base) => ({
                                            ...base,
                                            backgroundColor: "#e2e3e4",
                                        }),
                                        multiValueLabel: (base) => ({
                                            ...base,
                                            color: "#212529",
                                        }),
                                        multiValueRemove: (base) => ({
                                            ...base,
                                            color: "#000",
                                            cursor: "pointer",
                                            ":hover": {
                                                backgroundColor: "#999",
                                                color: "#fff",
                                            },
                                        }),
                                    }}
                                />
                            </div>

                        </Row>


                    </div>

                </Modal.Body>
                <div className="modalFooter">
                    <div className="row ">
                        <div className="col-md-12 text-right">
                            <button type="button" className="btn closeBtn" onClick={this.handleClose}>Cancel</button>
                            {
                                (!this.state.simulationExpiresOn || new Date(this.state.simulationExpiresOn) > new Date()) &&
                                <Button className={` btn btn-success ml-2`} onClick={this.props.campaignReportScheduler?.id ? this.handleUpdateScheduler : this.handleAddScheduler} >
                                    <Spinner loading={this.state.loading}></Spinner>
                                    Save
                                </Button>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
